(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_flexi-layout-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector('form');
          this.variantIdInput = this.form.querySelector('[name="id"]');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');
          this.spinner = this.querySelector('.flexi-loading-spinner');
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.quantityInput = this.querySelector('[name="quantity"]');

          this.variantIdInput.disabled = false;

          // Add event listener for the quantity input
          if (this.quantityInput) {
            this.quantityInput.addEventListener('input', this.onQuantityChange.bind(this));
          }

          // Add event listener for the form submission
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        onQuantityChange(evt) {
          // Prevent form submission on quantity change
          evt.preventDefault();
          const quantity = parseInt(evt.target.value, 10) || 1;
          if (quantity < 1) {
            this.quantityInput.value = 1;
          }
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.toggleLoadingState(true);

          const formData = new FormData(this.form);
          const config = {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          };

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          fetch('/cart/add.js', config)
            .then((response) => response.json())
            .then((data) => {
              if (data.status) {
                this.handleErrorMessage(data.description || 'An error occurred.');
                this.toggleSubmitButton(true, 'Sold Out');
                return;
              }

              if (this.cart) {
                this.triggerCartNotification(data);
              } else {
                window.location = '/cart';
              }
            })
            .catch((err) => console.error(err))
            .finally(() => this.toggleLoadingState(false));
        }

        triggerCartNotification(cartData) {
          if (this.cart.tagName.toLowerCase() === 'cart-notification') {
            this.cart.renderContents(cartData);
          } else if (this.cart.tagName.toLowerCase() === 'cart-drawer') {
            this.cart.renderContents(cartData);
            this.cart.classList.add('is-open');
          }
        }

        toggleLoadingState(isLoading) {
          if (isLoading) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            if (this.spinner) {
              this.spinner.classList.add('visible');
            }
            const atcContent = this.submitButton.querySelector('.flexi-atc-content');
            if (atcContent) {
              atcContent.classList.add('hidden');
            }
          } else {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            if (this.spinner) {
              this.spinner.classList.remove('visible');
            }
            const atcContent = this.submitButton.querySelector('.flexi-atc-content');
            if (atcContent) {
              atcContent.classList.remove('hidden');
            }
          }
        }

        handleErrorMessage(errorMessage = '') {
          const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
          const errorElement = this.querySelector('.product-form__error-message');
          if (!errorWrapper || !errorElement) return;

          if (errorMessage) {
            errorWrapper.hidden = false;
            errorElement.textContent = errorMessage;
          } else {
            errorWrapper.hidden = true;
          }
        }

        toggleSubmitButton(disable, text) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = 'Add to Cart';
          }
        }
      }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    const initProductBlazeSliders = () => {
      document.querySelectorAll('.flexi-product-slider').forEach((slider) => {
        // Initialize Blaze Slider
        const sliderInstance = new BlazeSlider(slider, {
          all: {
            slidesToShow: 1,
            slidesToScroll: 1,
            loop: false,
            draggable: true,
            slidesToShow: 1.2,
            prevArrow: slider.querySelector('.blaze-prev'),
            nextArrow: slider.querySelector('.blaze-next'),
          },
          '(max-width: 1024px)': {
            slidesToShow: 1.2,
          },
        });
      });
    };

    initProductBlazeSliders();

    document.addEventListener('shopify:section:load', initProductBlazeSliders);
  });
  } catch(e) { console.error(e); }
})();

})();
